import { Loading } from "@mozioinc/ui";
import { ErrorBoundary } from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Suspense } from "react";
import { GeneralError } from "./components";
import { router } from "./routes";
import { queryClient } from "./utils/query-client";

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loading className="h-screen" />}>
        <ErrorBoundary fallback={<GeneralError className="h-screen" />}>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </Suspense>
    </QueryClientProvider>
  );
};
